import { useQuery } from '@hooks/reactQuery';

import { getConsistencyCheckHistoryDetails } from '@api/consistencyCheckParameters';

import { extractQueryParams } from '@utils/common';

import { IConsistencyCheckHistoryDetail } from '@interfaces/cmModule/consistencyCheck';
import { IConsistencyCheckHistoryDetailsDTO } from '@interfaces/cmModule/dto/consistencyCheckDTO';

import { EUserRoles } from '@enums/common';

import { refetchOptions } from '@constants/common';
import { CONSISTENCY_CHECK_HISTORY_DETAILS } from '@constants/queryKeys';

interface IUseConsistencyCheckHistoryDetails {
	consistencyCheckDetails: IConsistencyCheckHistoryDetail[];
	moNames: string[];
	createdAt: string;
	countOfRecords: number;
	isLoadingConsistencyCheckHistoryDetails: boolean;
}

const useConsistencyCheckHistoryDetails = (
	params: Partial<IConsistencyCheckHistoryDetailsDTO>,
): IUseConsistencyCheckHistoryDetails => {
	const {
		data,
		isInitialLoading,
		isFetching,
	} = useQuery({
		queryKey: [CONSISTENCY_CHECK_HISTORY_DETAILS, params],
		queryFn: extractQueryParams(getConsistencyCheckHistoryDetails),
		enabled: [!!params.dumpConsistencyId],
		allowedRoles: [
			EUserRoles.networkOperatorCmModuleViewer,
			EUserRoles.networkOperatorCmModuleEditor,
			EUserRoles.networkOperatorCmModuleAdmin,
		],
		...refetchOptions,
	});

	return {
		consistencyCheckDetails: data?.rows?.items || [],
		moNames: data?.moNames || [],
		createdAt: data?.createdAtText || '',
		countOfRecords: data?.rows.count || 0,
		isLoadingConsistencyCheckHistoryDetails: isInitialLoading || isFetching,
	};
};

export default useConsistencyCheckHistoryDetails;
